import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const PaiePage = () => {

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Navbar />
            {/* Bannière avec image de fond */}
            <div className="w-full pt-16 pb-10 relative h-72" style={{ backgroundImage: 'url(/images/COMING-SOON-HEADER.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
            </div>

            <div className="flex flex-col -translate-y-44 lg:max-w-6xl mx-auto flex flex-col items-center lg:flex-row lg:items-center lg:justify-between px-4 relative z-10">
                <Link to="/" className="flex items-center text-sm mb-4 hover:underline text-white">
                    <span className="mr-2 text-lg text-white">&larr;</span> Page d'accueil
                </Link>
            </div>
            <div className="-translate-y-44 lg:max-w-6xl mx-auto flex flex-col items-center lg:flex-row lg:items-center lg:justify-between px-4 relative z-10">
                <div className="">
                    <img src="/svg/COMING-SOON.svg" alt="Dowonou RH Mockup" className="w-[800px]" />
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default PaiePage; 